import Anatomy from '~/pages/anatomy/intro/libs/components/Anatomy'
import { TPageProps } from '~/shared/types/commonTypes'

const IntroAnatomy = ({ nextPagePath }: TPageProps) => (
  <Anatomy nextPagePath={nextPagePath} />
)

export default IntroAnatomy
